import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../Context/AuthContext";
import dictionary from "../../util/dictionary";
export default function Header() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const onLogout = () => {
    localStorage.removeItem("la_procure@user");
    navigate("/");
    window.location.reload();
  };
  // Theme state with localStorage initialization
  const [theme, setTheme] = useState(
    () => localStorage.getItem("la_procure@theme") || "light-theme"
  );
  useEffect(() => {
    // Update body class and save to localStorage whenever the theme changes
    document.body.classList.remove("light-theme", "dark-theme");
    document.body.classList.add(theme);
    localStorage.setItem("la_procure@theme", theme);
  }, [theme]);
  const toggleTheme = () => {
    setTheme((prevTheme) =>
      prevTheme === "light-theme" ? "dark-theme" : "light-theme"
    );
  };
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };
  return (
    <>
      <div className="main-header side-header sticky">
        <div className="main-container container-fluid">
          <div className="main-header-left">
            <a
              className="main-header-menu-icon"
              href="javascript:void(0);"
              id="mainSidebarToggle"
            >
              <span />
            </a>
            <div className="hor-logo">
              <a className="main-logo" href="/">
                <img
                  src={process.env.PUBLIC_URL + "/assets/img/brand/logo.png"}
                  className="header-brand-img desktop-logo"
                  alt="logo"
                />
                <img
                  src={
                    process.env.PUBLIC_URL + "/assets/img/brand/logo-light.png"
                  }
                  className="header-brand-img desktop-logo-dark"
                  alt="logo"
                />
              </a>
            </div>
          </div>
          <div className="main-header-center">
            <div className="responsive-logo">
              <a href="/">
                <img
                  src={process.env.PUBLIC_URL + "/assets/img/brand/logo.png"}
                  className="mobile-logo"
                  alt="logo"
                />
              </a>
              <a href="/">
                <img
                  src={
                    process.env.PUBLIC_URL + "/assets/img/brand/logo-light.png"
                  }
                  className="mobile-logo-dark"
                  alt="logo"
                />
              </a>
            </div>
            <div className="input-group">
              <input
                type="search"
                className="form-control rounded-0"
                placeholder="Search for anything..."
              />
              <button className="btn search-btn">
                <i className="fe fe-search" />
              </button>
            </div>
          </div>
          <div className="main-header-right">
            <button
              className="navbar-toggler navresponsive-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent-4"
              aria-controls="navbarSupportedContent-4"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <i className="fe fe-more-vertical header-icons navbar-toggler-icon" />
            </button>
            <div className="navbar navbar-expand-lg nav nav-item navbar-nav-right responsive-navbar navbar-dark">
              <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent-4"
              >
                <div className="d-flex order-lg-2 ms-auto">
                  {/* Theme Toggle */}
                  <div className="dropdown d-flex main-header-theme">
                    <a
                      className="nav-link icon layout-setting"
                      onClick={toggleTheme}
                      style={{ cursor: "pointer" }}
                    >
                      {theme === "light-theme" ? (
                        <i
                          className="fe fe-moon header-icons"
                          style={{ color: "darkblue" }}
                        />
                      ) : (
                        <i
                          className="fe fe-sun header-icons"
                          style={{ color: "wheat" }}
                        />
                      )}
                    </a>
                  </div>
                  <div className="dropdown d-flex main-header-theme">
                    <a
                      className="nav-link icon layout-setting"
                      onClick={onLogout}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fe fe-power" />
                    </a>
                  </div>
                  {/* Full screen */}
                  <div className="dropdown">
                    <a className="nav-link icon full-screen-link">
                      <i className="fe fe-maximize fullscreen-button fullscreen header-icons" />
                      <i className="fe fe-minimize fullscreen-button exit-fullscreen header-icons" />
                    </a>
                  </div>
                  {/* Notification */}
                  <div className="dropdown main-header-notification">
                    <a className="nav-link icon" href="javascript:void(0);">
                      <i className="fe fe-bell header-icons" />
                      <span className="badge bg-danger nav-link-badge">4</span>
                    </a>
                    <div className="dropdown-menu">
                      <div className="header-navheading">
                        <p className="main-notification-text">
                          You have 1 unread notification
                          <span className="badge bg-pill bg-primary ms-3">
                            View all
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Profile */}
                  <div
                    className={`dropdown main-profile-menu ${
                      isOpen ? "show" : ""
                    }`}
                  >
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        toggleDropdown();
                      }}
                      className="d-flex"
                      href="#"
                    >
                      <span className="main-img-user">
                        <img
                          alt="avatar"
                          src={`${dictionary.apiHost}/img/avatar.png`}
                        />
                      </span>
                    </a>
                    <div className="dropdown-menu">
                      <div className="header-navheading">
                        {
                          <>
                            <h6 className="main-notification-title">
                              {user.first_name + " " + user.last_name}
                            </h6>
                          </>
                        }
                        <p className="main-notification-text">
                          {user.role?.role_name}
                        </p>
                      </div>
                      <a
                        className="dropdown-item border-top"
                        href="/user/profile"
                      >
                        <i className="fe fe-user" /> My Profile
                      </a>
                      <a className="dropdown-item" onClick={onLogout} href="#">
                        <i className="fe fe-power" /> Sign Out
                      </a>
                    </div>
                  </div>
                  {/* Profile */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
